module.exports = __webpack_public_path__ + "static/media/kitty_mug_shot.7b263184.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/kitty_mug_shot.jpg
// module id = 454
// module chunks = 0